export const DEFAULT_RADIO = [
  { label: '否', value: '0' },
  { label: '是', value: '1' },
];

export const TYPE_LIST = [
  { name: '满减券', value: 'CASH_COUPON' },
  { name: '折扣券', value: 'DISCOUNT_COUPON' },
  //目前团购券不支持
  // { name: '团购券', value: 'GROUP_COUPON' },
  { name: '兑换券', value: 'EXCHANGE_COUPON' },
  // 满折券
  { name: '满折券', value: 'FULL_DISCOUNT_COUPON' },
];

export const EXCHANGE_COUPON = 'EXCHANGE_COUPON';

export const CONTROL_RULES = [
  {
    label: '每人每月最多兑换',
    value: '1',
    isRightShow: true,
    name: 'monthlyExchangeNum',
    rightWord: '个礼品',
  },
];
export const NEW_MEMBER_CONTROL_RULES = [
  {
    label: '新会员注册期限：注册',
    value: '1',
    isRightShow: true,
    name: 'memberThresholdDay',
    rightWord: '天内，视作新会员',
  },
];
export const VIP_TYPE = [
  { name: '新会员', label: '新会员', value: '1' },
  { name: '老会员', label: '老会员', value: '2' },
];
